import styled from "styled-components";
import { DividerProps } from "./Divider";

export const Container = styled.div<DividerProps>`
  border: 1px solid #ecf2fb;
  align-self: center;
  margin: 10px 0;
  width: ${(props) => (props.width ? `${props.width}` : "100%")};
`;
